class Navigation {

    constructor() {

        this.navtrigger = $('.jsNavTrigger');
        this.navcontainer = $('.jsNavContainer');
        this.html = $('html');
        this.body = $('body');
        this.main = $('main');

        //set scrolling variables
        this.scrolling = false;
        this.scrollPositionBeforeOpen = $(window).scrollTop();
        this.open = false;

        // enable transitions to prevent edge/ie bug
        $(() => {
            this.navcontainer.addClass('has-transition');
        });

        // scroll event
        $(window).on('scroll', () => {

            let scrollTop = $(window).scrollTop();

            // auto hide only if nav is closed
            if(!this.open) {
                this.scrollPositionBeforeOpen = scrollTop
            }

        });

        // assign click action to trigger
        this.navtrigger.click((e) => {

            e.preventDefault();

            // open nav
            if(!this.html.hasClass('nav-open')) {

                this.open = true;

                // add html class
                this.html.addClass('nav-open');

                // set main negative position
                this.main.css('top', this.scrollPositionBeforeOpen * -1);

                // disable fullpage scrolling
                if(typeof fp != 'undefined') {
                    fp.disableScrolling();
                }

                this.navcontainer.bind('transitionend webkitTransitionEnd oTransitionEnd', () => {
                    if(this.html.hasClass('nav-open')) {
                        this.html.addClass('nav-open-finished');
                    }
                    this.navcontainer.unbind('transitionend webkitTransitionEnd oTransitionEnd');
                });

                // timeout prevents flickering on safari...
                window.setTimeout(() => {
                    $(window).scrollTop(0);
                });

            // close nav
            } else {

                // fadeout the overlay
                this.body.addClass('fadeout-overlay');
                this.navcontainer.bind('transitionend webkitTransitionEnd oTransitionEnd', () => {
                    this.body.removeClass('fadeout-overlay');
                    this.navcontainer.unbind('transitionend webkitTransitionEnd oTransitionEnd');
                });

                this.html.removeClass('nav-open-finished');
                this.html.removeClass('nav-open');

                // return to current top scroll position
                $(window).scrollTop(this.scrollPositionBeforeOpen);

                // re-enable fullpage scrolling
                if(typeof fp != 'undefined') {
                    fp.enableScrolling();
                }

                this.open = false;
            }
        })
    }

}

export default Navigation;